
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  Tags are used to provide contextual information; find related content using
  keywords, labels or links. Tags are also used as keywords in search boxes,
  filters and category lists. In some cases, they can be added or removed by the
  user.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <p>{`There are 2 variants of tags to accommodate different needs.`}</p>
    <h3>{`Link tags`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Constraint`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`URL-link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Removable tags`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Constraint`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Dismiss icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`When to use`}</h2>
    <h3>{`Link tags`}</h3>
    <ul>
      <li parentName="ul">{`To navigate to another page/content.`}</li>
      <li parentName="ul">{`To link current content to other related content.`}</li>
      <li parentName="ul">{`To show information which helps a user make sense of the content on the page, such as filter parameters or object metadata.`}</li>
      <li parentName="ul">{`To display information that clarifies the content on the page, such as metadata.`}</li>
      <li parentName="ul">{`To showcase the specific attributes of an item.`}</li>
      <li parentName="ul">{`To display applied filters or options.`}</li>
    </ul>
    <h3>{`Removable tags`}</h3>
    <ul>
      <li parentName="ul">{`To dismiss a tag from a search query, for example search filters, facets...`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <h3>{`Link tags`}</h3>
    <ul>
      <li parentName="ul">{`Avoid using too many tags as they might cause a visual overload.`}</li>
      <li parentName="ul">{`Avoid using tags that are too long (more than 3 words).`}</li>
      <li parentName="ul">{`Don’t use tags that are redundant.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;